const REVENUE_BASE_URL = 'https://www.hubspot.com/hubfs/pricing_page/revenue';
export const STRIPE_ICON_URL = `${REVENUE_BASE_URL}/stripe.png`;
export const APPLE_PAY_ICON_URL = `${REVENUE_BASE_URL}/apple-pay.png`;
export const GOOGLE_PAY_ICON_URL = `${REVENUE_BASE_URL}/google-pay.png`;
export const KLARNA_ICON_URL = `${REVENUE_BASE_URL}/klarna.png`;
export const AFFIRM_ICON_URL = `${REVENUE_BASE_URL}/affirm.png`;